// Both helpers compare a plan id against a target id coming from different
// sources (Vuex store, API response, v-model) that may not agree on
// number vs string — always compare via Number() so callers don't need to
// normalize ids before calling these helpers.
export function isChangedPlan(
  planId: number | string,
  changedPlanId: number | string | undefined | null,
): boolean {
  return (
    changedPlanId !== undefined
    && changedPlanId !== null
    && Number(planId) === Number(changedPlanId)
  );
}

export function findSelectedPlan<T extends { id?: number | string }>(
  plans: T[],
  selectedPlanId: number | string | null,
): T | undefined {
  return plans.find(
    (plan) => plan.id !== undefined
      && selectedPlanId !== null
      && Number(plan.id) === Number(selectedPlanId),
  );
}
